import { render, staticRenderFns } from "./UploadFileComponent.vue?vue&type=template&id=d10addac&scoped=true"
import script from "./UploadFileComponent.vue?vue&type=script&lang=js"
export * from "./UploadFileComponent.vue?vue&type=script&lang=js"
import style0 from "./UploadFileComponent.vue?vue&type=style&index=0&id=d10addac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10addac",
  null
  
)

export default component.exports